export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function monthLabel(month, year) {
  const name = MONTH_NAMES[Number(month) - 1] || month;
  return `${name}/${year}`;
}

export function accountLabel(bankAccount) {
  if (!bankAccount) return "-";
  return (
    `${bankAccount.bank?.bank_name || ""} ${bankAccount.account || ""}`.trim() ||
    "-"
  );
}

export const monthOptions = MONTH_NAMES.map((name, index) => ({
  value: index + 1,
  label: name,
}));

export const yearOptions = (() => {
  const current = new Date().getFullYear();
  const years = [];
  for (let year = current + 1; year >= current - 3; year -= 1) {
    years.push({ value: year, label: String(year) });
  }
  return years;
})();
